import { render, staticRenderFns } from "./LandingTitle.vue?vue&type=template&id=456aacde&scoped=true"
import script from "./LandingTitle.vue?vue&type=script&lang=js"
export * from "./LandingTitle.vue?vue&type=script&lang=js"
import style0 from "./LandingTitle.vue?vue&type=style&index=0&id=456aacde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456aacde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456aacde')) {
      api.createRecord('456aacde', component.options)
    } else {
      api.reload('456aacde', component.options)
    }
    module.hot.accept("./LandingTitle.vue?vue&type=template&id=456aacde&scoped=true", function () {
      api.rerender('456aacde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingTitle.vue"
export default component.exports